<template>
  <transition name="fade">
    <div v-if="loading" class="app-loader-overlay">
      <div class="app-loader-content">
        <v-progress-circular indeterminate color="primary" size="64" width="7" />
        <span v-if="message" class="app-loader-message">
          {{ message }}
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppLoader',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.app-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(30, 30, 30, 0.45);
  backdrop-filter: blur(2.5px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}
.app-loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 18px;
  padding: 36px 32px 28px 32px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.1);
  min-width: 220px;
}
.app-loader-message {
  margin-top: 22px;
  font-size: 1.18rem;
  color: #1976d2;
  text-align: center;
  font-weight: 500;
  word-break: break-word;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
